import {FormValidator} from "../../../../tools/form/form-validator";
import {EcgPreanalysisFormModel} from "./ecg-preanalysis-data.component";

type maybeNumber = number | undefined;

function isPositiveInteger(n: maybeNumber): boolean {
  return Number.isInteger(n) && n! > 0;
}

function isMeasuredValuePositiveInteger(flag: boolean, value: maybeNumber): boolean {
  return flag || isPositiveInteger(value);
}

export class EcgPreanalysisDataFormValidator extends FormValidator<EcgPreanalysisFormModel> {
  constructor(model: EcgPreanalysisFormModel) {
    super(new Map([
      ["pqInterval", () => isMeasuredValuePositiveInteger(model.pqCannotMeasure, model.pqInterval)],
      ["pqHeartRate", () => isMeasuredValuePositiveInteger(model.pqCannotMeasure, model.pqHeartRate)],
      ["qtInterval", () => isMeasuredValuePositiveInteger(model.qtCannotMeasure, model.qtInterval)],
      ["qtHeartRate", () => isMeasuredValuePositiveInteger(model.qtCannotMeasure, model.qtHeartRate)],
      ["qrsInterval", () => isMeasuredValuePositiveInteger(model.qrsCannotMeasure, model.qrsInterval)],
      ["qrsHeartRate", () => isMeasuredValuePositiveInteger(model.qrsCannotMeasure, model.qrsHeartRate)],
      ["pqInterval2", () => isMeasuredValuePositiveInteger(model.pq2NotPresent, model.pqInterval2)],
      ["pqHeartRate2", () => isMeasuredValuePositiveInteger(model.pq2NotPresent, model.pqHeartRate2)],
      ["pqInterval3", () => isMeasuredValuePositiveInteger(model.pq3NotPresent, model.pqInterval3)],
      ["pqHeartRate3", () => isMeasuredValuePositiveInteger(model.pq3NotPresent, model.pqHeartRate3)],
    ]));
  }
}
